import { USER_TYPE } from './types';

export const userType = (data) => async dispatch => {
  try {
    dispatch({ type: USER_TYPE, payload: data });
  } catch (errors) {
    // dispatch({ type: SET_ERRORS, payload: { error: "Unable to get current step" }});
  }
};